export default "__VITE_ASSET__23d134aa__"